import {
  Box,
  chipClasses,
  Container,
  styled,
  Table,
  TableCell,
  tableCellClasses,
  TableRow,
  Typography
} from '@mui/material';
import TitleUnderlineSvg from './title-underline.svg?react';

export const ReportContainer = styled(Box)(({ theme }) => ({
  fontFamily: 'avenir-lt-w01_85-heavy1475544,sans-serif',
  '& a': {
    textDecoration: 'none'
  },
  '.MuiTabs-root button': {
    color: theme.palette.common.black
  },

  '.MuiTabs-root .Mui-selected': {
    color: '#00ccff'
  },
  '.MuiTabs-root .MuiTabs-indicator': {
    backgroundColor: '#00ccff'
  }
}));

export const Title = styled(Typography)(() => ({
  fontFamily: '"League_Spartan variant0", Tofu, sans-serif'
}));

export const Section = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2)
}));

export const SectionContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  maxWidth: theme.breakpoints.values.lg
}));

export const StyledTable = styled(Table)(() => ({
  pageBreakInside: 'auto'
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: 'center',
    '@media print': {
      padding: 2,
      fontSize: 12
    }
  },
  [`&.${tableCellClasses.root}`]: {
    padding: '16px 10px'
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: 'center',
    padding: '4px 3px',
    '@media print': {
      padding: '4px 2px',
      fontSize: 10
    }
  },
  [`> .${chipClasses.root}`]: {
    background: 'transparent',
    [`& .${chipClasses.label}`]: {
      minWidth: '80px'
    }
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  pageBreakInside: 'avoid',
  pageBreakAfter: 'auto',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  },
  '&.highlight': {
    backgroundColor: '#00ccff'
  }
  // '&:nth(6)': {
  //   pageBreakAfter: 'always'
  // }
}));

export const TitleUnderline = styled(TitleUnderlineSvg)`
  width: 184px;
  height: 18px;
  transform: rotate(4.27273552905325deg);
`;

export const PageBreakBefore = {
  pageBreakBefore: 'always'
};

export const NoPageBreakBefore = {
  pageBreakBefore: 'avoid'
};

export const NoPageBreakInside = {
  pageBreakInside: 'avoid'
};

// Common spacing styles
export const ChipMarginBottom = {
  mb: 0.5
};

export const DividerMargin = {
  my: 2
};

export const LinkMarginRight = {
  mr: 1
};

export const ButtonMarginRight = {
  mr: 1
};

// Table row styles
export const TotalRowStyle = {
  bgcolor: 'common.black'
};

export const TotalLabelCellStyle = {
  color: 'brand.main' as const,
  fontWeight: 'bold' as const
};

export const TotalValueCellStyle = {
  color: 'common.white' as const,
  fontWeight: 'bold' as const
};

export const HighlightCellStyle = {
  fontWeight: 'bold' as const,
  bgcolor: 'grey.A400' as const
};

// TextField styles for ShareHistory
export const ShareLinkTextFieldStyle = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'grey.50',
    fontSize: '0.875rem',
    '&:hover': {
      backgroundColor: 'grey.100'
    }
  }
};

// MeterGroupItem styles
export const MeterGroupItemContainerStyle = {
  '&:hover .delete-group-button': { visibility: 'visible' as const }
};

export const MeterGroupItemHeaderStyle = {
  cursor: 'pointer' as const,
  width: '100%',
  pl: 2,
  pr: 1,
  paddingY: 1,
  borderRadius: 1,
  fontSize: 16,
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  bgcolor: 'background.default',
  '.MuiTouchRipple-child': {
    bgcolor: 'grey.A400'
  }
};

export const DeleteButtonStyle = {
  visibility: 'hidden' as const,
  ml: 'auto'
};

// CurrentVsNewSection styles
export const CenterAlignedSectionContainerStyle = {
  textAlign: 'center' as const
};

export const CurrentContractCaptionStyle = {
  display: 'block' as const,
  mt: 0.5
};

export const YearTabDateContainerStyle = {
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  flexWrap: 'wrap' as const
};
